import { PenIcon, SalaryIcon } from 'assets';
import { Button } from 'components/Button';
import { Salary } from 'models/Salary';
import { FC, RefObject } from 'react';
import { formatNumber } from 'utils/formatNumber';
import { SectionBlock } from 'components/layout/SectionBlock';
import { formatCurrency } from 'utils/formatCurrency';

import './SalaryVariablesCard.styles.scss';

type SalaryVariablesCardProps = {
  multiplierName: string;
  grossSalary?: Salary;
  netSalary?: Salary;
  onEditButtonClicked: () => void;
  containerRef: RefObject<HTMLDivElement>;
};

const SalaryVariablesCard: FC<SalaryVariablesCardProps> = (props) => {
  const { multiplierName, netSalary, grossSalary, onEditButtonClicked, containerRef } = props;

  return (
    <SectionBlock
      title={
        <>
          <div className='salary-icon'>
            <SalaryIcon />
          </div>
          Salary information
        </>
      }
      className='salary-variables-card'
      asideFromTitle={
        <Button
          variant='icon'
          onClick={onEditButtonClicked}
          className='salary-variables-card__button'
          aria-label='Edit'
        >
          <PenIcon />
        </Button>
      }
    >
      <div className='salary-variables-card__content' ref={containerRef}>
        <div className='salary-variables-card__row'>
          <b>Used multiplier:</b>
          <p>{multiplierName || '/'}</p>
        </div>
        <div className='salary-variables-card__row'>
          <b>Net salary:</b>
          {netSalary ? (
            <p>
              {formatNumber(netSalary?.amount || 0, 2)} {formatCurrency(netSalary?.currency)()}
            </p>
          ) : (
            <p>/</p>
          )}
        </div>
        <div className='salary-variables-card__row'>
          <b>Gross salary:</b>
          {grossSalary ? (
            <p>
              {formatNumber(grossSalary?.amount || 0, 2)} {formatCurrency(grossSalary?.currency)()}
            </p>
          ) : (
            <p>/</p>
          )}
        </div>
      </div>
    </SectionBlock>
  );
};

export default SalaryVariablesCard;
